import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Hero AI-first search affordance for the Knowledge Centre — a styled readonly bar that opens the
 * blended-search overlay (it does not take typed input itself).
 *
 * Feature-local copy of the former `@pitchin/ui` `pin-kc-search-bar` (ADR-0006).
 */
@Component({
  selector: 'kc-search-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="ai-searchbar tw-flex tw-items-center tw-gap-3 tw-bg-white tw-border-2 tw-border-primary tw-rounded-[14px] tw-shadow-[0_14px_40px_rgba(191,32,38,.14)] tw-p-2 tw-pl-[18px] tw-cursor-text">
      <svg class="tw-text-primary tw-flex-shrink-0" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2l1.9 4.6L18.5 8l-3.8 3 1.1 5L12 13.8 8.2 16l1.1-5L5.5 8l4.6-1.4z"/>
      </svg>
      <input
        class="tw-flex-1 tw-border-none tw-outline-none tw-text-[16.5px] tw-font-[inherit] tw-py-[13px] tw-bg-transparent tw-cursor-pointer"
        [placeholder]="placeholder || defaultPlaceholder"
        readonly
        (click)="aiClick.emit()"
      />
      <button
        class="tw-text-[12px] tw-text-[#9aa0a6] tw-bg-[#f4f5f7] tw-border-none tw-rounded-[8px] tw-px-3 tw-py-2 tw-font-[inherit] tw-cursor-pointer tw-whitespace-nowrap tw-flex-shrink-0"
        type="button"
        (click)="searchClick.emit(); $event.stopPropagation()"
      >Search instead</button>
      <button
        class="tw-flex-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold tw-text-[13.5px] tw-leading-none tw-px-[18px] tw-py-[10px] tw-rounded-[5px] tw-border tw-border-transparent tw-cursor-pointer tw-bg-primary tw-text-white"
        type="button"
        (click)="aiClick.emit(); $event.stopPropagation()"
      >&#10022; Ask AI</button>
    </div>
  `,
})
export class KcSearchBarComponent {
  @Input() placeholder = '';
  @Input() persona: 'investor' | 'issuer' = 'investor';
  @Output() searchClick = new EventEmitter<void>();
  @Output() aiClick = new EventEmitter<void>();

  get defaultPlaceholder(): string {
    return this.persona === 'issuer'
      ? 'Ask a question about fundraising…'
      : 'Ask a question about investing…';
  }
}
